const RANK = {
    // 热议榜
    HOT: 1,
    // 高股息榜
    HOT_DIVIDENDS: 2,
    // 对接对应市场下的卡片，来源 cmn_list_manager
    CARD: 3,
    // 自定义
    CUSTOM: 100
};

const MARKET = {
    HK: 'HK', // 港股
    US: 'US', // 美股
    CN: 'CN', // A股
    SG: 'SG', // 星股
    AU: 'AU', // 澳股
    CA: 'CA', // 加拿大
    JP: 'JP', // 日本
    MY: 'MY' // 马来西亚
};

const MARKET_ID = {
    // 注意: 两个榜市场枚举不一致
    [RANK.HOT]: {
        [MARKET.HK]: 1,
        [MARKET.US]: 2,
        [MARKET.CN]: 3,
        [MARKET.SG]: 4,
        [MARKET.AU]: 5,
        [MARKET.CA]: 6,
        [MARKET.JP]: 7,
        [MARKET.MY]: 8
    },
    [RANK.HOT_DIVIDENDS]: {
        [MARKET.HK]: 1,
        [MARKET.US]: 2,
        [MARKET.CN]: 3,
        [MARKET.SG]: 4,
        [MARKET.CA]: 5,
        [MARKET.AU]: 6,
        [MARKET.JP]: 7,
        [MARKET.MY]: 8
    },
    [RANK.CARD]: {
        [MARKET.HK]: 1,
        [MARKET.US]: 2,
        [MARKET.CN]: 3,
        [MARKET.SG]: 4,
        [MARKET.CA]: 5,
        [MARKET.AU]: 6,
        [MARKET.JP]: 7,
        [MARKET.MY]: 8
    }
};

const THEME = {
    LIGHT: 1,
    DARK: 3
};

const UP_DOWN_COLOR = {
    RED_UP: 0,
    GREEN_UP: 1
};

const HOT_TYPE = {
    ALL: 17,
    TRADE: 11,
    SEARCH: 13,
    NEWS: 15
};

const INCREASE_TYPE = {
    CLOSE: 'day',
    CLOSE_5DAY: 'close_5day',
    CLOSE_10DAY: 'close_10day',
    CLOSE_20DAY: 'close_20day',
    CLOSE_60DAY: 'close_60day',
    CLOSE_120DAY: 'close_120day',
    CLOSE_250DAY: 'close_250day',
    CLOSE_MONTH: 'close_month',
    CLOSE_YEAR: 'close_year'
};

const SORT_TYPE = {
    // 默认按照自定义顺序排序
    DEFAULT: 'default',
    // 按照涨幅排序
    INCREASE: 'increase',
};

export { RANK, MARKET, MARKET_ID, THEME, UP_DOWN_COLOR, HOT_TYPE, INCREASE_TYPE, SORT_TYPE };
